import UnclaimedGroupProfileHeader from './UnclaimedGroupProfileHeader';

export default UnclaimedGroupProfileHeader;
